export const MAC = "Mac";
export const WIN = "Windows";
export const LINUX = "Linux";
